export default class collapsable {

    constructor($el) {
        this.$el = $el;
        this.trigger = this.$el.querySelector('[data-collapsable-top]');
        this.text = this.$el.querySelector('[data-collapsable-text]');
        this.icon = this.$el.querySelector('[data-collapsable-icon]');
        this.textHeight = this.text.scrollHeight;

        this.toggleCollapsable = this.toggleCollapsable.bind(this);

        if (this.$el.dataset.collapsable === 'open') {
            this.toggleCollapsable();
        }

        this.trigger.addEventListener('click', this.toggleCollapsable);
    }

    toggleCollapsable() {
        if (! this.text.classList.contains('collapsable__text--open')) {
            this.text.classList.add('collapsable__text--open');
            if(this.icon) {
                this.icon.classList.add('collapsable__icon--open');
            }
        }
        else {
            this.text.classList.remove('collapsable__text--open');
            if(this.icon) {
                this.icon.classList.remove('collapsable__icon--open');
            }
        }
    }
}